import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

export interface ConfirmationDialogData {
  titulo?: string;
  texto?: string;
  textoButtonOk?: string;
  textoButtonCancelar?: string;
  cancelButton?: boolean;
}
@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation.component.html',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
})
export class ConfirmationComponent implements OnInit {
  texto?: string;
  titulo?: string;
  textoButtonOk?: string;
  textoButtonCancelar?: string;
  cancelButton?: boolean;

  constructor(
    private _dialogRef: MatDialogRef<ConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: ConfirmationDialogData,
  ) {}

  ngOnInit() {
    this.titulo = 'Confirmacion';
    this.texto = 'Esta Seguro?';
    this.textoButtonOk = 'Aceptar';
    this.textoButtonCancelar = 'Cancelar';
    this.cancelButton = true;
    if (this._data.titulo) {
      this.titulo = this._data.titulo;
    }
    if (this._data.texto) {
      this.texto = this._data.texto;
    }
    if (this._data.textoButtonOk) {
      this.textoButtonOk = this._data.textoButtonOk;
    }
    if (this._data.textoButtonCancelar) {
      this.textoButtonCancelar = this._data.textoButtonCancelar;
    }
    if (this._data.cancelButton !== undefined) {
      this.cancelButton = this._data.cancelButton;
    }
  }

  ok() {
    this._dialogRef.close({ res: true });
  }

  onNoClick() {
    this._dialogRef.close({ res: false });
  }
}
